import React, { memo, useMemo } from 'react'

import i18n from '@batical/i18n'
import { useContextValue } from '@batical/reducer/src'
import { CalculCodeStateKeys } from '@batical/types/src'

import { ViewLine, CalculText, CalculTextRight } from '..'

export type ResultIntermediateLineProps = {
  calculCode: CalculCodeStateKeys
  variableName: string
  trunc?: number
  unit?: string
  doCalcul?: boolean
  first?: boolean
  last?: boolean
}
const ResultIntermediateLine = ({ calculCode, variableName, trunc = 2, unit, first, last, doCalcul }: ResultIntermediateLineProps) => {
  const value = useContextValue(variableName, calculCode, doCalcul)[0]
  const text = useMemo(() => {
    let tex = i18n.t(`${calculCode}_${variableName}`)

    return tex
  }, [calculCode, variableName])

  const displayValue = useMemo(() => {
    if (value) {
      if (typeof value === 'string') {
        return value
      } else {
        return +value.toFixed(trunc)
      }
    }
    return '0'
  }, [trunc, value])

  return <ResultIntermediateLineManual title={text} value={displayValue} trunc={trunc} unit={unit} first={first} last={last} />
}

export type ResultIntermediateLineManualProps = {
  value: string | number
  title: string
  trunc?: number
  unit?: string
  first?: boolean
  last?: boolean
}
export const ResultIntermediateLineManual = ({ value, title, trunc = 2, unit, last, first }: ResultIntermediateLineManualProps) => {
  const text = useMemo(() => {
    let tex = title

    return tex
  }, [title])

  const displayValue = useMemo(() => {
    if (value) {
      if (typeof value === 'string') {
        return value
      } else {
        return +value.toFixed(trunc)
      }
    }
    return '0'
  }, [trunc, value])

  return (
    <ViewLine first={first} last={last}>
      <CalculText>{text}</CalculText>
      <CalculTextRight>
        {displayValue} {unit}
      </CalculTextRight>
    </ViewLine>
  )
}

export default memo(ResultIntermediateLine)
